import { DataTypes } from '@lexriver/data-types'
import { DomeManipulator, React } from '@lexriver/dome'
import cssAnimations from '../Animation.m.scss'
import appCss from '../App.m.scss'
import { Link } from '../components/Link'
import css from './PopupCookies.m.scss'

export module PopupCookies{
    // let divOverlay:HTMLDivElement
    let divPopup:HTMLDivElement
    let divContentContainer:HTMLDivElement

    // let escapeHandler = (e) => {
    //     //console.log('escapeHandler', e)
    //     if(e.key === 'Escape'){
    //         closePopup()
    //     }
    // }
    
    export async function showPopupAsync(){
        // Check cookie before showing popup
        if (document.cookie.includes('hideCookiesPopup=true')) {
            return;
        }
        //console.log('PopupAsync.showPopup')
        // divOverlay = <div class={appCss.blackOverlay}></div>
        // document.body.appendChild(divOverlay)
        // document.addEventListener('keyup', escapeHandler)
    
        divPopup = (
            <div class={css.popupContainer} >
                <div class={css.popup} ref={ref => divContentContainer = ref}>
                    <div>
                        Мы используем cookies. Используя сайт, вы соглашаетесь с <Link url='/policy'>обработкой данных</Link> с целью сбора аналитики. Cookies можно отключить в любой момент в настройках вашего браузера.
                    </div>
                    <div>
                        <button class={appCss.button} onClick={() => {
                            closePopup()
                        }}>Принять</button>
                    </div>
                    
                </div>
            </div>
        )
        
        document.body.appendChild(divPopup)
        // divPopup.classList.add(cssAnimations.zoomIn)
        // Removed call to loadContentAsync(getContent) because getContent is not defined
    }

    async function loadContentAsync(getContent:()=>Promise<HTMLElement|string>|HTMLElement|string){
        // console.log('PopupAsync.loadContentAsync')
        const el = await getContent()
        if(DataTypes.isString(el)){
            await DomeManipulator.replaceAllChildrenAsync(divContentContainer, <div style={{padding:'70px'}}>{el}</div>)
        } else {
            await DomeManipulator.replaceAllChildrenAsync(divContentContainer, el)
        }
    }
    
    export function closePopup(){
        if(!divPopup){
            throw new Error('unable to close popup, no divPopup')
        }
        // Set cookie to not show popup again (expires in 1 year)
        document.cookie = 'hideCookiesPopup=true; path=/; max-age=' + 60*60*24*365;
        // document.removeEventListener('keyup', escapeHandler)
        // divPopup.classList.remove(cssAnimations.zoomIn)
        divPopup.classList.add(cssAnimations.zoomOut)
        setTimeout(() => {
            divPopup.remove()
        }, 300)
    }
    
}